import { makeStyles } from '@material-ui/core/styles';
const useClasses = makeStyles(() => ({
    modal: {
        '.MuiPaper-root': {
            maxWidth: '500px',
            '::-webkit-scrollbar': { display: 'none' }
        }
    },
    content: { padding: '24px' },
    logoWrapper: { marginBottom: '16px', textAlign: 'center' },
    textWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    buttonWrapper: {
        gap: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '24px'
    },
    title: { fontSize: '16px', fontWeight: 600, lineHeight: '26px' },
    description: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '26px',
        textAlign: 'center'
    },
    icon: { height: '80px', width: '80px' }
}));
export default useClasses;
//# sourceMappingURL=modal.style.js.map